import PhaseOfPlay from "@Enums/PhaseOfPlay";
import PlayPositions from "@Enums/PlayPositions";
import useI18n from "@i18n";

export const getPositionSelectionDisplayText = (
  positions: PlayPositions[],
  i18n: (key: string) => string,
) => {
  if (positions.length === 0) return i18n("position.selection.random.positions");
  if (positions.length === 1) return i18n(`position.${positions[0].toLowerCase()}`);
  return i18n("position.selection.multiple.positions");
};

export const getPhaseSelectionDisplayText = (
  phases: PhaseOfPlay[],
  i18n: (key: string) => string,
) => {
  if (phases.length === 0) return i18n("position.selection.all.phases");
  if (phases.length === 1) return i18n(`phase.${phases[0].toLowerCase()}`);
  return i18n("position.selection.multiple.phases");
};

export const useSelectionDisplayText = () => {
  const { i18n } = useI18n();

  return {
    getPositionSelectionDisplayText: (positions: PlayPositions[]) => getPositionSelectionDisplayText(positions, i18n),
    getPhaseSelectionDisplayText: (phases: PhaseOfPlay[]) => getPhaseSelectionDisplayText(phases, i18n),
  };
};
